export * from "./badge.component";
export * from "./badge.module";
